/*! towsons-more-colours.js — the "More colours" mugs drawn with this product's own words.
 *
 * Philip, 4 Oct 2026, on https://wedomugs.com/products/dad: "The more colours bit, the 4
 * preview images, can we get the preview to show the content eg #Dad", and "Don't forget
 * the little image previews also render the treat!" The box (towsons-more-colours.liquid)
 * starts with each colour's plain mug — the very photo the drawing is made on, so it is
 * already in hand. Once the product's own photo is in and the box is in view, each colour
 * is drawn — this product's words on that colour's mug, and the treat chosen on this page,
 * if any — by the personaliser's own basket-line painter (towsons-personaliser.js
 * paintLine), from small copies of the mug photos: a frame 160px wide, photos 360px wide.
 *
 * Only when the mug's published views say how big their photos are (view.w): that is what
 * lets the painter use the small copies and still place the words right. Until then the
 * box keeps the personalised mug's own photos rather than download the full ones (~700 KB
 * each).
 *
 * SOONER, AND KEPT (TKT9F82C, 22 Oct 2026; Philip: "the extra colour images take a while to
 * render", then "quick tweak and any other tune-up we can do"). Timed on the live Kevin
 * page as a phone (4x CPU, slow 4G): the mugs came at 15.6 s on a first visit, 9.7 s on the
 * next. Three waits, each now gone:
 *   - this file was deferred, so it ran only once the whole page was parsed (7 s on that
 *     phone) though it was in hand at 1.8 s and the photo at 3.9 s. It is async now (its tag
 *     sits after the box, so the box is there), looks for the photo at once, and hands the
 *     painter these mugs the moment it arrives rather than at the page's end of parsing;
 *   - the personaliser's font check could never see Arimo arrive (towsons-personaliser.js
 *     faceLoaded) and sat out its 6 s every time;
 *   - nothing was kept between visits. A colour drawn with its fonts in is kept in this
 *     browser (localStorage, the last STORE_MAX pictures), and a later visit shows it at
 *     once — no painter, no fabric, no photos.
 * It also starts when the page is idle, not only when the box nears the screen, and asks
 * for the Google fonts the moment the bundle names them, alongside the painter.
 */
(function () {
  'use strict';
  if (window.__towsonsMoreColours) return;
  window.__towsonsMoreColours = true;

  var PHOTO_W = 360;   // the mug photos, fetched this wide
  var FRAME_W = 160;   // the picture drawn — four times the 40px it shows at

  function boxes() {
    return Array.prototype.slice.call(document.querySelectorAll('a[data-towsons-more-colours][data-config]'));
  }
  function parse(el, name) {
    try { return JSON.parse(el.getAttribute(name) || 'null'); } catch (e) { return null; }
  }

  // KEPT BETWEEN VISITS: each colour as last drawn, in this browser. Keyed by everything
  // the picture depends on — the mug's artwork version (change_id), the colour's blank, the
  // words, the treat, the size — so a changed design or a new treat is a new picture, never
  // a stale one. A 160px JPEG is ~6 KB as text: STORE_MAX of them stays well inside the
  // browser's allowance, and the oldest go first.
  var STORE = 'towsons-mc1:';
  var STORE_INDEX = 'towsons-mc1:index';
  var STORE_MAX = 160;
  function storeKey(cfg, valuesAttr, variantId, treatName) {
    var blank = (cfg && cfg.variant_blanks && cfg.variant_blanks[String(variantId)]) || '';
    return STORE + [cfg && cfg.template_id, cfg && cfg.change_id, blank, valuesAttr || '', treatName || '', FRAME_W].join('|');
  }
  function storage() { try { return window.localStorage || null; } catch (e) { return null; } }
  function readIndex(ls) {
    try { var a = JSON.parse(ls.getItem(STORE_INDEX) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; }
  }
  function recall(key) {
    var ls = storage();
    if (!ls) return null;
    try {
      var url = ls.getItem(key);
      if (url) {   // the most recently shown go last, so they are the last to go
        var idx = readIndex(ls).filter(function (k) { return k !== key; });
        idx.push(key);
        ls.setItem(STORE_INDEX, JSON.stringify(idx));
      }
      return url;
    } catch (e) { return null; }
  }
  function remember(key, url) {
    var ls = storage();
    if (!ls || !key || String(url).indexOf('data:image/') !== 0) return;
    try {
      var idx = readIndex(ls).filter(function (k) { return k !== key; });
      idx.push(key);
      while (idx.length > STORE_MAX) ls.removeItem(idx.shift());
      try { ls.setItem(key, url); } catch (full) {
        // The browser's allowance is shared with the rest of the shop: make room once.
        idx.splice(0, Math.floor((idx.length - 1) / 2)).forEach(function (k) { ls.removeItem(k); });
        ls.setItem(key, url);
      }
      ls.setItem(STORE_INDEX, JSON.stringify(idx));
    } catch (e) { /* kept or not, the picture is on the page */ }
  }
  function imgOf(mug) { return mug.parentElement ? mug.parentElement.querySelector('img') : null; }
  // Every colour that has a kept picture shows it now. → true when all of them did.
  function fillFromStore(box, treat) {
    var cfg = parse(box, 'data-config');
    if (!cfg) return false;
    var values = box.getAttribute('data-values') || '';
    var mugs = Array.prototype.slice.call(box.querySelectorAll('[data-towsons-mc-mug]'));
    var all = mugs.length > 0;
    mugs.forEach(function (m) {
      var img = imgOf(m);
      var url = img ? recall(storeKey(cfg, values, m.getAttribute('data-variant-id'), treat ? treat.name : '')) : null;
      if (!url) { all = false; return; }
      img.removeAttribute('srcset'); img.removeAttribute('sizes');
      img.__towsonsSrc = url;
      img.src = url;
    });
    return all;
  }

  // Every colour's first view — the one drawn — says how big its photo is, and is bigger
  // than the copy asked for. The Liquid makes the same test before it shows the plain mugs.
  function drawable(cfg, mugs) {
    if (!cfg || !cfg.bundle_url) return false;
    var map = cfg.variant_blanks || {};
    return mugs.length > 0 && mugs.every(function (m) {
      var blank = map[String(m.getAttribute('data-variant-id'))];
      var mock = blank && cfg.mockups && cfg.mockups[blank];
      var first = mock && mock.views && mock.views[0];
      return !!(first && first.url && Number(first.w) > PHOTO_W);
    });
  }

  // The treat chosen on this page: its name and the picture that rises out of the mug.
  function treatOf() {
    var root = document.querySelector('[data-towsons-treats]:not([data-line-mode])');
    if (!root) return null;
    var input = root.querySelector('[data-treats-value]');
    var name = input ? input.value : '';
    if (!name) return null;
    var row = null;
    Array.prototype.forEach.call(root.querySelectorAll('[role="option"]'), function (o) { if (!row && o.getAttribute('data-value') === name) row = o; });
    if (!row || row.getAttribute('data-none') === 'true') return null;
    var url = row.getAttribute('data-cutout') || row.getAttribute('data-image') || '';
    return url ? { name: name, url: url } : null;
  }
  function setTreat(mug, treat) {
    if (treat) { mug.setAttribute('data-treat', treat.name); mug.setAttribute('data-treat-image', treat.url); }
    else { mug.removeAttribute('data-treat'); mug.removeAttribute('data-treat-image'); }
    mug.__towsonsPainted = false;
  }

  // Each colour's marker becomes a basket-line marker the painter knows.
  function mark(box) {
    var cfg = parse(box, 'data-config');
    var mugs = Array.prototype.slice.call(box.querySelectorAll('[data-towsons-mc-mug]'));
    if (!drawable(cfg, mugs)) return false;
    var treat = treatOf();
    mugs.forEach(function (m) {
      ['data-config', 'data-values', 'data-fabric-src', 'data-tcd-src'].forEach(function (a) { m.setAttribute(a, box.getAttribute(a) || ''); });
      m.setAttribute('data-view', '0');
      m.setAttribute('data-photo-width', String(PHOTO_W));
      m.setAttribute('data-frame-width', String(FRAME_W));
      m.setAttribute('data-keep', '');   // the painter says when a colour is drawn with its fonts in
      setTreat(m, treat);
      m.setAttribute('data-towsons-line', '');
    });
    box.__towsonsMcMarked = true;
    return true;
  }

  // The painter is the personaliser's: called if it is on the page already (a basket
  // with a personalised line loads it), loaded once otherwise — it paints the markers as
  // it starts.
  //
  // EVERYTHING IT WILL ASK FOR, ASKED FOR AT ONCE (4 Oct 2026, Philip: "if you can tune
  // up the speed of it showing"). Left to itself the painter arrives, then asks for the
  // drawing scripts, then reads the bundle, then asks for its fonts: four waits in a row,
  // which on a phone was most of the time. So alongside the painter: the two drawing
  // scripts (preloaded — the painter's own <script> for each then finds it in hand), the
  // bundle (into the painter's own map of them, window.__towsonsBundles, which it reads
  // before fetching), and a connection to the font servers.
  function preload(href, as) {
    if (!href) return;
    var l = document.createElement('link');
    l.rel = 'preload'; l.as = as; l.href = href;
    document.head.appendChild(l);
  }
  function preconnect(origin) {
    var l = document.createElement('link');
    l.rel = 'preconnect'; l.href = origin; l.crossOrigin = 'anonymous';
    document.head.appendChild(l);
  }
  // The same shape as towsons-personaliser.js bundleFor: a promise of the parsed
  // bundle, dropped again if it fails.
  function warmBundle(url) {
    if (!url) return;
    var map = window.__towsonsBundles || (window.__towsonsBundles = {});
    if (map[url]) return;
    var p = map[url] = fetch(url, { mode: 'cors', credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('bundle HTTP ' + r.status);
      return r.json();
    });
    p.catch(function () { if (map[url] === p) delete map[url]; });
    p.then(warmFonts, function () {});
  }
  // The bundle's Google fonts asked for as soon as it names them, while the painter is still
  // on its way: their stylesheet put up the way the painter puts it up (towsons-personaliser.js
  // stylesheetLoaded — the same marker and the same promise on the link, so it finds this one
  // and waits on it), then each face asked for, which is what sends for its file.
  function warmFonts(bundle) {
    var href = bundle && bundle.google_css;
    if (!href || document.querySelector('link[data-towsons-google-fonts="' + href + '"]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet'; link.href = href;
    link.setAttribute('data-towsons-google-fonts', href);
    link.__towsonsLoaded = new Promise(function (resolve) {
      link.onload = resolve; link.onerror = resolve;
      setTimeout(resolve, 8000);
    });
    document.head.appendChild(link);
    link.__towsonsLoaded.then(function () {
      if (!document.fonts || !document.fonts.load) return;
      (bundle.google || []).forEach(function (g) {
        document.fonts.load((g.italic ? 'italic ' : '') + String(g.weight || 400) + ' 40px "' + g.family + '"', 'WARNING Danny #Sample 1234 WMil').catch(function () {});
      });
    });
  }
  var loading = false;
  function paint(box) {
    if (window.TowsonsPersonaliser && window.TowsonsPersonaliser.init) { window.TowsonsPersonaliser.init(); return; }
    if (loading) return;
    loading = true;
    var cfg = parse(box, 'data-config') || {};
    if ('fetch' in window) warmBundle(cfg.bundle_url);
    if (!window.fabric) preload(box.getAttribute('data-fabric-src'), 'script');
    if (!window.TcdRender) preload(box.getAttribute('data-tcd-src'), 'script');
    preconnect('https://fonts.googleapis.com');
    preconnect('https://fonts.gstatic.com');
    var s = document.createElement('script');
    s.src = box.getAttribute('data-personaliser-src');
    s.async = true;
    // The painter starts itself only once the page is parsed; these mugs it paints now.
    s.onload = function () {
      var P = window.TowsonsPersonaliser;
      if (P && typeof P.paintLines === 'function') P.paintLines();
    };
    s.onerror = function () { loading = false; };
    document.head.appendChild(s);
  }

  // What the box shows now: the kept pictures if every colour has one (nothing to load),
  // else the colours made ready and the painter asked. Again for each treat chosen.
  function show(box) {
    var treat = treatOf();
    if (fillFromStore(box, treat)) return;
    if (box.__towsonsMcMarked) {
      Array.prototype.forEach.call(box.querySelectorAll('[data-towsons-mc-mug]'), function (m) { setTreat(m, treat); });
    } else if (!mark(box)) {
      return;
    }
    paint(box);
  }
  function wake(box) {
    if (box.__towsonsMcAwake) return;
    box.__towsonsMcAwake = true;
    show(box);
  }

  // When the box is (nearly) in view — or the page has a quiet moment, whichever is first —
  // once the product's own photo is in. The box sits under the price, where most shoppers
  // look, so drawing it unasked costs little and saves the wait when they do.
  function watch() {
    var list = boxes();
    if (!list.length) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); wake(e.target); } });
      }, { rootMargin: '200px' });
      list.forEach(function (b) { io.observe(b); });
    } else {
      list.forEach(wake);
      return;
    }
    var idle = window.requestIdleCallback
      ? function (fn) { window.requestIdleCallback(fn, { timeout: 1500 }); }
      : function (fn) { setTimeout(fn, 600); };
    idle(function () { list.forEach(wake); });
  }
  // THE PRODUCT'S OWN PHOTO FIRST — not the whole page. This waited for the page's
  // "load", which waits for every script on it (reviews, Shop Pay, analytics): seconds on
  // a phone, long after the photo the shopper came for is showing. So: once the first
  // gallery photo is in (or has failed), or the page has loaded, or three seconds have
  // gone, whichever comes first. Looked for at once: this file runs as soon as it arrives
  // (async), and the gallery comes before the box in the page.
  // The photo showing: the selected slide's — on a product whose variants have photos of
  // their own it need not be the first in the page, and the first may be a hidden slide
  // that loads only when swiped to.
  var SHOWN_PHOTO = '.product-gallery__carousel-item.is-selected img';
  var MAIN_PHOTO = '.product-gallery__carousel-item img, .product__media-item img, .product__media img';
  function afterMainPhoto(fn) {
    var started = false;
    var go = function () { if (!started) { started = true; fn(); } };
    if (document.readyState === 'complete') { go(); return; }
    window.addEventListener('load', go);
    setTimeout(go, 3000);
    var look = function () {
      var img = document.querySelector(SHOWN_PHOTO) || document.querySelector(MAIN_PHOTO);
      if (!img || (img.complete && img.naturalWidth > 0)) { go(); return; }
      img.addEventListener('load', go);
      img.addEventListener('error', go);
    };
    if (document.readyState === 'loading' && !(document.querySelector(SHOWN_PHOTO) || document.querySelector(MAIN_PHOTO))) document.addEventListener('DOMContentLoaded', look);
    else look();
  }
  // Pictures kept from an earlier visit go up straight away, and that box has started (a
  // treat chosen later redraws it); the rest wait for the photo.
  var treatNow = treatOf();
  var waiting = boxes().filter(function (b) {
    if (!fillFromStore(b, treatNow)) return true;
    b.__towsonsMcAwake = true;
    return false;
  });
  if (waiting.length) afterMainPhoto(watch);
  // A colour the painter has drawn with its fonts in is kept for next time.
  document.addEventListener('towsons:painted', function (e) {
    var m = e.target;
    var box = m && m.closest && m.closest('a[data-towsons-more-colours]');
    if (!box || !e.detail || !e.detail.url) return;
    remember(storeKey(parse(box, 'data-config'), box.getAttribute('data-values'), m.getAttribute('data-variant-id'), m.getAttribute('data-treat') || ''), e.detail.url);
  });

  // A treat chosen (or "No thanks") on this page goes on the mugs too.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-treats-value]') || (t.closest && t.closest('[data-line-mode]'))) return;
    boxes().forEach(function (box) {
      // One not yet started reads the treat when it starts.
      if (box.__towsonsMcAwake) show(box);
    });
  });

  window.__towsonsMoreColours = { drawable: drawable, treatOf: treatOf, mark: mark, storeKey: storeKey, fillFromStore: fillFromStore, PHOTO_W: PHOTO_W, FRAME_W: FRAME_W, STORE_MAX: STORE_MAX };
})();
